import { isInternational } from '../global/_checkForInternational';
import { quickConvert } from '../international/_intl';
import { slickNSlide } from '../productDisplay/_maltImgSwipe';
import { flatSizeMobileQVPrice } from '../productDisplay/_flatSizeMobileQVPrice';
import { replaceImage } from './_images';
import Cookies from 'js-cookie';
import { getAllImages } from '../modals_2017/_attrQVfunct';

const moveShopperActions = (wrapper, actions) => {
	wrapper.append(actions);
};

const mobileMoveShopperActions = () => {
	if (Modernizr.mq('(max-width: 767px)')) {
		if ($('#mobile-shopper-wrapper').is(':empty')) {
			var desktopShopperActions = $('.desktop-shopper-actions').detach();
			moveShopperActions($('#mobile-shopper-wrapper'), desktopShopperActions);
		}
	}
};

const superMobileShopperActions = () => {
	if (Modernizr.mq('(min-width: 768px)')) {
		var desktopShopperWrapper = $('.desktop-shopper-actions-wrapper');
		if ($('.desktop-shopper-actions-wrapper').is(':empty')) desktopTabletMoveShopperActions();
		desktopShopperWrapper.parent().removeClass('hidden-xs');
		desktopShopperWrapper.parent().find('#product-social-wrapper').hide();
		desktopShopperWrapper.parent().find('#productpage-accordion').hide();
	}
};

const resizeShopperActions = () => {
	$(window).on(
		'resize',
		_.debounce(function () {
			if (Dillards.config.superMobile !== undefined && Dillards.config.superMobile && $('#mobile-shopper-wrapper').length > -1) superMobileShopperActions();
			else if (Dillards.config.superMobile !== undefined && !Dillards.config.superMobile && $('#mobile-shopper-wrapper').length > -1)
				mobileMoveShopperActions();
		})
	);
	superMobileShopperActions();
};

const desktopTabletMoveShopperActions = () => {
	var desktopShopperActions = $('.desktop-shopper-actions').detach();
	moveShopperActions($('.desktop-shopper-actions-wrapper'), desktopShopperActions);
};

const setMultipleProductImg = (that) => {
	replaceImage(that.parents('.list-item').find('.product-image:eq(0)'), that.data('fullimage'));
};

const setSelected = (that) => {
	$(that).prop('selected', true);
};

const allDevicesColorSelectBox = () => {
	
	$.fn.hideOpt = function () {
		if (this.parent().is('select')) this.parents('select').html('');
		return this;
	};
	$.fn.showOpt = function () {
		this.each(function () {
			var $this = $(this);
			if ($this.parent().is('div')) {
				var $select = $this.parents('form').find(`#${$this.parents('div').data('selectid')}`);
				if ($select.find(`option[data-attrValue='${$this.data('attrvalue')}']`).length == 0) $select.append($this.clone());
			}
		});
		return this;
	};

	//On mobile if Color or Initial Attrs that require a main image change are accidentally a button, this will handle that event
	$('ul.qvAttr li').on('click', function (e) {
		let selVal = e.target.innerHTML;
		let attrName = e.target.getAttribute('data-attrname');
		let mainImage = $(this).parents('.modal-body').find('.mainImage')[0];
		let newImage = $(this).data('fullimage');
		if(attrName === 'initial' || attrName === 'Initial' || attrName === 'color' || attrName === 'Color') {
		$(mainImage).hide();
			let getDivSKUS = JSON.parse(document.getElementById('allSkus').innerText);
			let allImages = getAllImages(getDivSKUS);
			let attrValue = null;
			let attrImg = '';
			Object.values(allImages).map((val => {
				let getAttrType = val.attrName;
				let getAttrValue = val.attrValue;
				let getAttrImg = val.imgName;
				if(getAttrValue == selVal) {
					attrImg = getAttrImg;
				}
			}))
			if(attrImg) {
				newImage = attrImg;
			}
			replaceImage($(mainImage), newImage);
			$(mainImage).show();
		}
	 } );

	$('.alt-image-tile').on('click', function (e) {
		let selVal = e.target.innerHTML;
		let attrName = e.target.getAttribute('data-attrname');
		let mainImage = $(this).parents('.modal-body').find('.mainImage')[0];
		let newImage = $(this).data('fullimage');
		if(attrName === 'initial' || attrName === 'Initial') {
			$(mainImage).hide();
			let getDivSKUS = JSON.parse(document.getElementById('allSkus').innerText);
			let allImages = getAllImages(getDivSKUS);
			let attrValue = null;
			let attrImg = '';
			Object.values(allImages).map((val => {
				let getAttrType = val.attrName;
				let getAttrValue = val.attrValue;
				let getAttrImg = val.imgName;
				if(getAttrValue == selVal) {
					attrImg = getAttrImg;
				}
			}))
			if(attrImg) {
				newImage = attrImg;
			}
			replaceImage($(mainImage), newImage);
			$(mainImage).show();
		}
		
	})

	var $selectBoxes = $('select.form-control').not($('.quantity-select'));
	if ($('p.qv-item-num').length > 0) $selectBoxes = $('.modal-quickview').find('select.form-control').not($('.quantity-select'));
	//cache options
	// $selectBoxes.each(function () {
	// 	var $form = $(this).parents('form'),
	// 		$select = $(this);
	// 	if ($form.parents().hasClass('list-item')) $('.size-select').removeClass('select-hide');
	// 	if ($form.find(`#options${$select.attr('id').length == 0}`)) {
	// 		$form.append('<div class="hidden" data-selectid="' + $select.attr('id') + '" id="options' + $select.attr('id') + '"></div>');
	// 		$form.find('#options' + $select.attr('id')).append($select.find('option').clone());
	// 	}
	// });

	$selectBoxes.on('change propertychange', function (e) {
		var selectedValue = $(this).val(),
			selectedOption = undefined,
			$form = $(this).parents('form'),
			thisSelect = $(this),
			allSkus = $('input#skus').val(),
			ColorSelected = $(this).find(':selected').data('attrvalue');

		var val = thisSelect.find(':selected').data('attrvalue');
		var errorMessage = $(this).siblings('.popover-error');
		if (val != '*') {
			errorMessage.remove();
		}

		// update and scroll to selected swatch
		if ($('.desktopPage #quickviewModalDesktop').length > 0 && $(this).hasClass('color-select')) {
			$.each($form.find($('.swatchListItem .swatchImage')), function (index, item) {
				var swatchColorname = $(this).attr('data-colorname');
				if (ColorSelected === swatchColorname) {
					$('.swatchList').slick('slickGoTo', index);
					$(item).addClass('swatch-selected');
					$(item).parent().attr('aria-current', 'true');
				} else if (ColorSelected != swatchColorname) {
					$(item).removeClass('swatch-selected');
					$(item).parent().attr('aria-current', 'false');
				}
			});
		}

		$(this).find(':selected').data('id');
		if (ColorSelected === '*') {
			if ($('.dynamicModalContainer').length == 0) {
				$('.size-select-flat li').removeClass('DisabledFlatSize');
				$('.thisPrice').remove();
				$('.shipping-message').hide();
				$('#mainPrice .price-wrapper').show();
				$('.orgNowPrice').show();
				$('.thisSalePrice').hide();
			} else {
				$('.dynamicModalContainer .size-select-flat li').removeClass('DisabledFlatSize');
				$('.dynamicModalContainer .thisPrice').remove();
				$('.dynamicModalContainer #mainPrice .price-wrapper').show();
				$('.dynamicModalContainer .orgNowPrice').show();
				$('.dynamicModalContainer .thisSalePrice').hide();
				$('.dynamicModalContainer .price-number').show();
			}
			if ($('.original-price').length == 0 && $('.now-price').length == 0 && $('.price-number').text().indexOf('-') !== -1) {
				$('.price-number').show();
			}
		}

		if (
			$('.dynamicModalContainer').length == 0 &&
			ColorSelected !== '*' &&
			$('.size-select-flat').find('.size-selected').length > 0 &&
			$('.size-selected').data('othersprice')
		) {
			// this if statement is for placing the price of the item above the "add to bag" button if there is a price range
			var chosenSize = $('.size-selected'),
				chosenSizeOthersPrice = chosenSize.data('othersprice'),
				yourPrice = '';
			$(chosenSizeOthersPrice.split('|')).each(function () {
				if (this.split(':')[0] == ColorSelected) {
					yourPrice = this.split(':')[1];
				}
			});
			var currency = $('.price-number').text(),
				currencyString = currency.search(/\d/),
				currencyFinal = currency.substring(0, currencyString),
				priceVal = Cookies.get('zCountry') == 'US' ? yourPrice : quickConvert(yourPrice),
				sizePriceContainer = $(`<span class='thisPrice'>$${priceVal}</span>`);
			$('.thisPrice').remove();
			$('.shipping-message').hide();
			var showShipsFreeThreshold = $('[data-showshipsfree]').length > 0 ? $('[data-showshipsfree]').data('showshipsfree') : 999999;

			//Below is for changing the price displayed

			if ($('.original-price').length > 0) {
				var origPrice = $('header .original-price .price-number').text();
				var origPriceIndex = origPrice.lastIndexOf('$');
				var origPriceFinal = origPrice.substring(origPriceIndex + 1);

				if ($('.swatch-selected').parents().parents().siblings().hasClass('price-wrapper') > 0 && origPriceFinal != priceVal) {
					$('.thisPrice').remove();
					$('.thisSalePrice').remove();
					$('#mainPrice .price-wrapper').show();
					$('#mainPrice .now-price').addClass('orgNowPrice');
					$('.orgNowPrice').hide();

					$('#mainPrice .price-wrapper').append($(`<span class="thisSalePrice price now-price">Now<span class="price-number">$${priceVal}</span></span>`));
				} else {
					$(sizePriceContainer).insertBefore($('#mainPrice .price-wrapper'));
					if (yourPrice >= showShipsFreeThreshold) {
						$('.shipping-message').show();
					}
					$('#mainPrice .price-wrapper').hide();
				}
				if (yourPrice == '' || $('.swatch-selected').length === 0) {
					$('.thisPrice').remove();
					$('#mainPrice .price-wrapper').show();
					$('.orgNowPrice').show();
					$('.thisSalePrice').hide();
				}
			} else {
				$('#mainPrice.price-wrapper .price').prepend(sizePriceContainer);
				if (yourPrice >= showShipsFreeThreshold) {
					$('.shipping-message').show();
				}
				$('#mainPrice .price-number').hide();

				if ($('.size-selected').length === 0) {
					$('#mainPrice .price-number').show();
				}
				if ($('.swatch-selected').length === 0) {
					$('#mainPrice .price-number').show();
					$('.thisPrice').remove();
				}
			}

			//End of changing the price displayed
		}
		if ($('.modal').length === 0) {
			if ($('.alt-image-list-container ul li').length > 4) {
				var selectedColor = $(this).find(':selected').data('fullimage');
				$.each($('.alt-image-list-container').find('img'), function () {
					var altImgData = $(this).attr('data-fullimage');
					if (selectedColor == altImgData) {
						var altImg = $(this).position();
						if (Dillards.config.deviceClass === 'desktopPage') {
							$('.alt-image-list-container ul').animate(
								{
									top: -altImg.top,
								},
								75
							);
						}
					}
					$(this).offset() === $('.alt-image-list-container ul').offset()
						? $('.alt-image-nav-up').addClass('disabled-arrow')
						: $('.alt-image-nav-up').removeClass('disabled-arrow');
				});
			}
		}
		if ($('#type-of-card').length == 0 && $('.chanel-bundle').length == 0) {
			//mainImageSwap prod pages
			if ($('p.qv-item-num').length == 0) {
				$(this)
					.find('option')
					.each(function () {
						if ($(this).attr('value') == selectedValue) {

							selectedOption = $(this);
							if ($(this).data('fullimage')) {
								let mainImgSlideConditions = !($('.desktopPage').length > 0 || $('.outfit-display-page').length > 0 || $('.chanel-only').length > 0);
								if (mainImgSlideConditions && $('.mainProductImage .slick-active img').length > 0) {
									let selectedColor = $(this).data('fullimage');
									if (selectedColor.indexOf('zi_') > -1) slickNSlide(selectedColor);
									if ($(this).parents('.list-item').length > 0) setMultipleProductImg($(this));
								} else {
									if ($(this).parents('.list-item').length > 0) setMultipleProductImg($(this));
									else {
										if ($('.outfit-display-page').length > 0) {
											let productImg = $(this).parents('.sto_item').find('figure > img');
											replaceImage(productImg, $(this).data('fullimage'));
											productImg.prop('alt', `${$(this).data('attrvalue')}:${$('#product-title').text()}`);
										} else {
											//if main image is a broken image
											if ($('.mainImage').attr('src').indexOf('/assets/img/') > -1) {
												$('.mainImage').attr(
													'src',
													$(`img.alt-image-tile[data-fullimage="${$(this).data('fullimage')}"]`)
														.attr('src')
														.split('/alt/')
														.join('/main/')
												);
											} else {
												replaceImage($('.mainImage'), $(this).data('fullimage'));
												$('.mainImage').prop('alt', `${$(this).data('attrvalue')}:${$('#product-title').text()}`);
											}
										}
									}
								}
							}
						}
					});
			} else {
				// quick view main image update
				var mainImage = $(this).parents('.modal-body').find('.mainImage')[0],
					thisVal = $(this).val(),
					colorSelect = $(this).hasClass('color-select'),
					initialSelect = $(this).attr('data-attrname');
					$.each($(this).find('option'), function () {
					if ($(this).attr('value') == thisVal) {
						selectedOption = $(this);
						if (thisVal != '' && colorSelect || initialSelect.length > 0) {
							var newImage = $(this).data('fullimage');
							$(mainImage).hide();
							//if the main image is a broken image
							if ($('.mainImage').attr('src').indexOf('/assets/img/') > -1 || $('.mainImage').attr('src').indexOf('shim.gif') > -1) {
								if ($(`img.alt-image-tile[data-fullimage="${$(this).data('fullimage')}"]`).attr('src'))
									$('.mainImage').attr(
										'src',
										$(`img.alt-image-tile[data-fullimage="${$(this).data('fullimage')}"]`)
											.attr('src')
											.split('/alt/')
											.join('/main/')
									);
							} else {
								let getDivSKUS = JSON.parse(document.getElementById('allSkus').innerText);
								let allImages = getAllImages(getDivSKUS);
								let attrValue = null;
								let attrImg = '';
								Object.values(allImages).map((val => {
									let getAttrType = val.attrName;
									let getAttrValue = val.attrValue;
									let getAttrImg = val.imgName;
									if(getAttrValue == thisVal && (getAttrType === 'Color' || getAttrType === 'Initial')) {
										attrImg = getAttrImg;
									}
								}))
								if(attrImg) {
									newImage = attrImg;
									replaceImage($(mainImage), newImage);
								}

							}
							$(mainImage).show();
						}
					}
				});
			}

			// leaving all this commented out until we know for sure we dont need any of it

			// get the selected option and the not-selected select
			// var otherOptions = selectedOption.data('others'),
			// var otherSelect = $(this).parents('form').find('select').not($(this)).not($('.quantity-select,.disregard-dropdown'));
			// // remove pricing from the selected dropdown
			// if (otherSelect.length) {
			// 	$(this)
			// 		.find('option')
			// 		.not($(this).find('option').eq(0))
			// 		.each(function () {
			// 			$(this).html($(this).data('attrvalue'));
			// 		});
			// }

			// limit options in the not-selected dropdown
			// var thisForm = $(this).parents('form');
			// if (
			// 	$('.size-select-flat').length == 0 ||
			// 	($('#quickviewModalDesktop').length > 0 && $('#quickviewModalDesktop .size-select-flat').length == 0) ||
			// 	($('#quickviewOssModalDesktop').length > 0 && $('#quickviewOssModalDesktop .size-select-flat').length == 0)
			// ) {
			// 	if (otherSelect.length) {
			// 		var otherSelectVal = otherSelect.val();
			// 		if (selectedValue !== '') {
			// 			if ($('.desktopPage #quickviewModalDesktop').length > 0) {
			// 				// otherSelect.find('option').removeClass('available unavailable').attr('disabled', false);
			// 				$(String(otherOptions).split('|')).each(function () {
			// 					thisForm.find(`option[data-attrvalue='${String(this)}']`).addClass('available');
			// 				});
			// 				// removes all of the pricing options from the not-selected dropdown and disables unavailable options
			// 				var remainingOptions = otherSelect.children().not('.available').not('option[data-attrvalue="*"]');
			// 				for (var xRemaining = 0; xRemaining < remainingOptions.length; xRemaining++) {
			// 					// var thisOption = remainingOptions[xRemaining];
			// 					// // $(thisOption).addClass('unavailable');
			// 					// var pricingRemoved = $(thisOption).text().split(' -')[0];
			// 					// $(thisOption).text(pricingRemoved);
			// 					// $(thisOption).attr('disabled', true);
			// 				}
			// 				// adds strike-through on unavailable swatches
			// 				if ($(otherSelect).hasClass('form-control color-select')) {
			// 					// var unavailableColorOptions = otherSelect.children('.unavailable');
			// 					// var newOptionsArray = [];
			// 					// for (var n = 0; n < unavailableColorOptions.length; n++) {
			// 					// 	var currentColorOption = unavailableColorOptions[n];
			// 					// 	var thisOptionColor = currentColorOption.dataset.attrvalue;
			// 					// 	newOptionsArray.push(thisOptionColor);
			// 					// }
			// 					// var allSwatches = $('.swatchListItem .swatchImage');
			// 					// for (var a = 0; a < allSwatches.length; a++) {
			// 					// 	var currentSwatch = allSwatches[a];
			// 					// 	var currentSwatchColor = currentSwatch.dataset.colorname;
			// 					// 	if ($.inArray(currentSwatchColor, newOptionsArray) == -1) {
			// 					// 		$(currentSwatch).parent().prev().removeClass('swatches-notAvailable');
			// 					// 	} else {
			// 					// 		$(currentSwatch).parent().prev().addClass('swatches-notAvailable');
			// 					// 	}
			// 					// }
			// 				}
			// 			} else {
			// 				// otherSelect.find('option').hideOpt();
			// 				// thisForm.find('option[data-attrvalue="*"]').showOpt();
			// 				// $(String(otherOptions).split('|')).each(function () {
			// 				// 	thisForm.find(`option[data-attrvalue='${String(this)}']`).showOpt();
			// 				// });
			// 			}
			// 		} else {
			// 			// otherSelect.find('option').hideOpt();
			// 			// thisForm.find('option').showOpt();
			// 		}
			// 		// otherSelect.val(otherSelectVal);
			// 		// if (selectedValue == '' && otherSelectVal != '') otherSelect.trigger('change');
			// 	}
			// }

			//limitSwatches
			// if ($('.size-select-flat').length == 0 || $('#quickviewModalDesktop').length > 0 || $('#quickviewOssModalDesktop').length > 0) {
			// 	if (otherSelect.length) {
			// 		var thisForm = $(this).parents('form');
			// 		thisForm.find('.swatch-group').hide();
			// 		thisForm.find('.swatch-group img').hide();
			// 		thisForm.find('.swatch-group').each(function () {
			// 			var thisGroupsImages = $(this).find('img');
			// 			var thisGroup = $(this);
			// 			thisGroupsImages.each(function () {
			// 				if (
			// 					thisForm
			// 						.find(`option[data-attrvalue="${$(this).data('colorname')}"]`)
			// 						.parent()
			// 						.is('select')
			// 				) {
			// 					thisGroup.show();
			// 					$(this).show();
			// 				}
			// 			});
			// 		});
			// 	}
			// }

			//add pricing to available options
			// var otherOptionsPrice = selectedOption.data('othersprice');
			// if (otherSelect.length) {
			// 	if (selectedValue !== '' && otherOptionsPrice) {
			// 		$(otherOptionsPrice.split('|')).each(function () {
			// 			var otherOptionsPriceSplit = this.split(':');
			// 			if (isInternational()) {
			// 				var split1 = quickConvert(otherOptionsPriceSplit[1]);
			// 				otherSelect.find("option[data-attrvalue='" + otherOptionsPriceSplit[0] + "']").html(otherOptionsPriceSplit[0] + ' - ' + split1);
			// 			} else otherSelect.find("option[data-attrvalue='" + otherOptionsPriceSplit[0] + "']").html(otherOptionsPriceSplit[0] + ' - $' + otherOptionsPriceSplit[1]);
			// 		});
			// 	} else {
			// 		otherSelect.find('option').each(function () {
			// 			if ($(this).val() !== '') $(this).html($(this).data('attrvalue'));
			// 		});
			// 	}
			// }

			// update free shipping message for items with price ranges


			// document.querySelector('#freeShippingMsg.saveOnSelect')
			// var otherSelect = $(this).parents('form').find('select').not($(this)).not($('.quantity-select,.disregard-dropdown'));
			// console.log(otherSelect)

			// if ($('#freeShippingMsg.saveOnSelect').length > 0) {
			// 	if (otherSelect.find(':selected').val() !== '') {
			// 		var otherSelectPrice = parseFloat(otherSelect.find(':selected').text().split('$').pop());
			// 		console.log('otherSelectPrice')
			// 		console.log(otherSelectPrice)
			// 		if (!isNaN(otherSelectPrice)) {
			// 			console.log(!isNaN(otherSelectPrice) + '--!isNaN(otherSelectPrice')
			// 			if (otherSelectPrice >= 150) {
			// 				$('#freeShippingMsg.saveOnSelect').show();
			// 			} else {
			// 				$('#freeShippingMsg.saveOnSelect').hide();
			// 			}
			// 		}
			// 	}
			// 	if (otherSelect.find(':selected').val() === '') {
			// 		var availablePrice = parseFloat(otherSelect.find('option.available').first().text().split('$').pop());
			// 		console.log('availablePrice')
			// 		console.log(availablePrice)
			// 		if (availablePrice >= 150) {
			// 			$('#freeShippingMsg.saveOnSelect').show();
			// 		} else {
			// 			$('#freeShippingMsg.saveOnSelect').hide();
			// 		}
			// 	}
			// }
		}
		if (
			($form.parents().hasClass('product-select-boxes') || $form.parents().hasClass('chanel-only') || $form.parents().hasClass('item-attr-display')) &&
			!$('.modal-quickview').length > 0 &&
			!$('.bundle-display-page').length > 0 &&
			!$('.outfit-display-page').length > 0
		) {
			var thisSelectForm = $(this).parents('form');
			var colorDD = $(this);
			var AvSizes = $(this).find('option:selected').attr('data-others');
			if (AvSizes != undefined) {
				var AvSizesArray = AvSizes.split('|');
				$('.size-select-flat li').addClass('DisabledFlatSize');

				$.each(thisSelectForm.find($('.size-select-group-flat > ul > li')), function () {
					var thisSizeVal = $(this).attr('data-attrvalue');
					var thisFlatSize = $(this);
					if (AvSizesArray.indexOf(thisSizeVal) !== -1) {
						thisFlatSize.removeClass('DisabledFlatSize');
					}
				});
			} else {
				$('.size-select-flat li').removeClass('DisabledFlatSize');
			}
		}
		if ($('.bundle-display-page').length > 0 && $('#quickviewModalMobile').length > 0) {
			var thisSelectForm = $(this).parents('form');
			var colorDD = $(this);
			var AvSizes = $(this).find('option:selected').attr('data-others');
			if (AvSizes != undefined) {
				var AvSizesArray = AvSizes.split('|');
				$('.size-select-flat li').addClass('DisabledFlatSize');

				$.each(thisSelectForm.find($('.size-select-group-flat-qv > ul > li')), function () {
					var thisSizeVal = $(this).attr('data-attrvalue');
					var thisFlatSize = $(this);
					if (AvSizesArray.indexOf(thisSizeVal) !== -1) {
						thisFlatSize.removeClass('DisabledFlatSize');
					}
				});
			} else {
				$('.size-select-flat li').removeClass('DisabledFlatSize');
			}
		}
		if (
			($form.parents().hasClass('product-select-boxes') || $form.parents().hasClass('chanel-only') || $form.parents().hasClass('item-attr-display')) &&
			!$('.desktopPage .modal-quickview').length > 0 &&
			!$('.tabletPage .modal-quickview').length > 0 &&
			!$('.bundle-display-page').length > 0 &&
			!$('.outfit-display-page').length > 0
		) {
			var thisSelectForm = $(this).parents('form');
			var colorDD = $(this);
			var AvSizes = $(this).find('option:selected').attr('data-others');
			if (AvSizes != undefined) {
				var AvSizesArray = AvSizes.split('|');
				$('.size-select-group-flat-qv .size-select-flat li').addClass('DisabledFlatSize');

				$.each(thisSelectForm.find($('.size-select-group-flat-qv > ul > li')), function () {
					var thisSizeVal = $(this).attr('data-attrvalue');
					var thisFlatSize = $(this);
					if (AvSizesArray.indexOf(thisSizeVal) !== -1) {
						thisFlatSize.removeClass('DisabledFlatSize');
					}
				});
			} else {
				$('.size-select-flat li').removeClass('DisabledFlatSize');
			}
		}

		// flatSizeMobileQVPrice(ColorSelected);

		$form.find('.size-select-group-flat > ul > li').each(function () {
			//if you have a size slected and then select a swatch the size will update to check if it needs to add the class 'has-error' or remove class 'has-error'
			if ($(this).hasClass('size-selected')) {
				$(this).parents().parents('.size-select-group-flat').siblings('.size-select-group').removeClass('has-error');
				setSelected(`.size-select option[value="${$('.size-selected').attr('value')}"]`);
			}
			if ($(this).hasClass('size-selected') && $(this).hasClass('DisabledFlatSize')) {
				$(this).parents().parents('.size-select-group-flat').siblings('.size-select-group').addClass('has-error');
				setSelected('.size-select option:eq(0)');
			}

			if ($('.original-price').length == 0 && $('.now-price').length == 0) {
				if ($('.size-selected').hasClass('DisabledFlatSize')) {
					$('.thisPrice').remove();
					$('.price-number').show();
				}
			}
		});
		$form.find('.size-select-group-flat-qv > ul > li').each(function () {
			//This is for QV. Currently only on mobile
			//if you have a size slected and then select a color the size will update to check if it needs to add the class 'has-error' or remove class 'has-error'
			if ($(this).hasClass('size-selected')) {
				var qvSizeSelectedValue = $(this).attr('value');
				$(this).parents().parents('.size-select-group-flat-qv').siblings('.size-select-group').removeClass('has-error');
				setSelected(`.dynamicModalContainer .size-select option[value="${qvSizeSelectedValue}"]`);
			}
			if ($(this).hasClass('size-selected') && $(this).hasClass('DisabledFlatSize')) {
				$(this).parents().parents('.size-select-group-flat-qv').siblings('.size-select-group').addClass('has-error');
				setSelected('.dynamicModalContainer .size-select option:eq(0)');
			}
		});

		$.each($('.size-select-flat li'), function () {
			//ADA
			var $this = $(this);
			$this.hasClass('DisabledFlatSize') ? $this.attr('aria-label', 'Not Available') : $this.attr('aria-label', 'Available');
		});
		// $('.color-select-group .popover-error').remove();
	});

	// handle available swatch click
	$('#static-quickViewSwatches .swatchImage').on('click', function (event) {
		var getSwatchColor = event.target.dataset.colorname;
		var getSelectOptions = $('select.color-select').children();
		$(getSelectOptions).each(function () {
			if ($(this).attr('data-attrvalue') == getSwatchColor) {
				$(this).prop('selected', true);
				$('.color-select').trigger('change');
			}
		});
		try {
			if (typeof zonos === 'object') {
				setTimeout(function () {
					zonos.displayCurrency();
				}, 300);
			}
		} catch (e) {
			console.log(e);
		}
	});

	// handle unavailable swatch click
	// $('span.swatchSpan').on('click', function (event) {
	// 	var getSwatchColor = event.target.nextElementSibling.firstElementChild.dataset.colorname;
	// 	var getSelectOptions = $('select.color-select').children();
	// 	$(getSelectOptions).each(function () {
	// 		if ($(this).attr('data-attrvalue') == getSwatchColor) {
	// 			$(this).attr('disabled', false);
	// 			$(this).prop('selected', true);
	// 			$('.color-select').trigger('change');
	// 		}
	// 	});
	// });

	if ($('.outfit-display-page').length > 0 && $('p.qv-item-num').length == 0) {
		$selectBoxes.each(function () {
			if ($(this).val() != '*') $(this).trigger('change');
		});
	}
};

export { allDevicesColorSelectBox, desktopTabletMoveShopperActions, mobileMoveShopperActions, superMobileShopperActions, resizeShopperActions, setSelected };
